import { html, PropertyValues, TemplateResult } from 'lit';
import {
  API_TYPE_NIRVANA, WEB_COMPONENT_EXECUTIVE_SUMMARY_INCIDENTS,
} from '../../../../webcomponents.constants';
import { GzGenericWidgetContent } from '../../../../genericDashboard/gzGenericWidget';
import { customElement, property, query } from 'lit/decorators.js';
import { GetWidgetDataRequest } from '../../../../types/widget/types';
import { Observable, of } from 'rxjs';
import {
  GetIncidentsStatusResponse, IncidentsStatusPayload,
} from '@nirvana/shared/dtos/types/widgets/common';
import { translateFn } from '../../../../utils/translator.helper';
import { getTimezone } from '../../../../utils/global.utils';
import { IncidentsWebComponent } from '../../../../incidentsStatus';
import { getDisplayMode, sanitizeReportingPeriod } from '../../../utils/utils';

@customElement(WEB_COMPONENT_EXECUTIVE_SUMMARY_INCIDENTS)
export class GzIncidentsStatusWebComponent extends GzGenericWidgetContent {
  @property({ type: Object, attribute: true, reflect: true })
  payload: IncidentsStatusPayload;

  @query('#gzIncidentsStatus')
  private incidentsStatus: IncidentsWebComponent;

  injectDependencies(dependencies: any) {
    this.dependencies = dependencies;
  }

  getPayload() {
    return this.payload;
  }

  updated(_changedProperties: PropertyValues): void {
    super.updated(_changedProperties);

    const dependencies = {
      Ext: this.dependencies ? this.dependencies.Ext : undefined,
      getTimezone: getTimezone,
      getUserLanguage: Application.Main.getLanguage,
      translateFn: translateFn,
      api: {
        type: API_TYPE_NIRVANA,
        clients: {
          Widgets: {
            getIncidentsStatus: function (request: GetWidgetDataRequest): Observable<GetIncidentsStatusResponse> {
              return of(this.getPayload().incidentsStatus);
            }.bind(this)
          }
        }
      }
    };

    if (this.incidentsStatus) {
      if (!this.incidentsStatus.started) {
        this.incidentsStatus.injectDependencies(dependencies);
        this.incidentsStatus.start();
      } else {
        this.incidentsStatus.controller?.render();
      }
    }
  }

  protected renderContent(): TemplateResult {
    return html `
      <gz-incidents id="gzIncidentsStatus"
                    data-reporting-period=${JSON.stringify(sanitizeReportingPeriod(this.payload?.reportingPeriod))}
                    data-targets=${JSON.stringify(this.payload?.targets)}
                    data-can-drill-down=${true}
                    data-display-mode=${getDisplayMode()}
      ></gz-incidents>`;
  }
}
